define([
	"dojo/_base/declare",
	"./_VectorNumber"
], function(declare,_VectorNumber) {

	return declare(_VectorNumber, {
		bRenderComparisonValues: true,
		cssBaseSize: " TargetBase",
		html1: '<span class="increment">'
	});
});